export function search() {
	let input = document.getElementById('searchfield');

	if(input) {
		input.addEventListener('keyup', function(event) {
			if (event.keyCode === 13) {
				event.preventDefault();
				document.getElementById('searchButton').click();
			}
		});
	}
}